<app-breadcrumbs></app-breadcrumbs>
<div class="store-number-toolbar">
  <div [cfaLoading]="isLoading">
    <button mat-raised-button (click)="getWanHealth()" color="primary" id="store-number-search-button">
      <mat-icon>search</mat-icon>
    </button>
    <mat-form-field id="store-number-search-field" appearance="outline">
      <mat-label>Store Number</mat-label>
      <input matInput maxlength="5" minlength="5" (keydown.enter)="getWanHealth()" [(ngModel)]="storeNumber" autofocus/>
    </mat-form-field>
  </div>
  <app-health-nav [storeNumber]="storeNumber"></app-health-nav>
</div>
<div class="slo-evaluation-wrapper">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Service Level Objective Evalutation</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-divider></mat-divider>
      <table class="table" id="slo-evaluation-table">
        <thead>
          <tr>
            @if (circuit != null) {
              <th scope="col">Circuit</th>
            }
            @if (circuit != null) {
              <th scope="col">Loss</th>
            }
            @if (circuit != null) {
              <th scope="col">Latency</th>
            }
            @if (circuit != null) {
              <th scope="col">Jitter</th>
            }
            @if (bandwidthUtilization != null) {
              <th scope="col">Band Util %</th>
            }
            @if (throughputTest != null) {
              <th scope="col">Throughput Test</th>
            }
            @if (signalHealth != null) {
              <th scope="col">SINR</th>
            }
            @if (signalHealth != null) {
              <th scope="col">RSRQ</th>
            }
          </tr>
        </thead>
        <tbody>
          <tr>
            @if (circuit != null) {
              <td>
                <span id="green-badge">
                  <mat-icon matTooltip="Available" matTooltipPosition="right">check_circle_outline
                  </mat-icon>
                </span>
              </td>
            }
            @if (circuit != null) {
              <td>
                @if (circuit.loss < 10) {
                  <span id="green-badge">
                    <mat-icon matTooltip="Less than 10%" matTooltipPosition="right">check_circle_outline
                    </mat-icon>
                  </span>
                }
                @if (circuit.loss >= 10) {
                  <span id="red-badge">
                    <mat-icon matTooltip="Greater than or equal to 10%" matTooltipPosition="right">
                    highlight_off</mat-icon>
                  </span>
                }
              </td>
            }
            @if (circuit != null) {
              <td>
                @if (circuit.avgLatency < 85) {
                  <span id="green-badge">
                    <mat-icon matTooltip="Less than 85 ms" matTooltipPosition="right">check_circle_outline
                    </mat-icon>
                  </span>
                }
                @if (circuit.avgLatency >= 85) {
                  <span id="red-badge">
                    <mat-icon matTooltip="Greater than or equal to 85 ms" matTooltipPosition="right">
                    highlight_off</mat-icon>
                  </span>
                }
              </td>
            }
            @if (circuit != null) {
              <td>
                @if (circuit.jitter < 20) {
                  <span id="green-badge">
                    <mat-icon matTooltip="Less than 20 ms" matTooltipPosition="right">check_circle_outline
                    </mat-icon>
                  </span>
                }
                @if (circuit.jitter >= 20) {
                  <span id="red-badge">
                    <mat-icon matTooltip="Greater than or equal to 20 ms" matTooltipPosition="right">
                    highlight_off</mat-icon>
                  </span>
                }
              </td>
            }
            @if (bandwidthUtilization != null) {
              <td>
                @if (bandwidthUtilization.bitsIn/20 < 85 && bandwidthUtilization.bitsOut/20 < 85) {
                  <span
                    id="green-badge">
                    <mat-icon matTooltip="Greater than 85% (for 20x20)" matTooltipPosition="right">
                    check_circle_outline</mat-icon>
                  </span>
                }
                @if (bandwidthUtilization.bitsIn/20 >= 85 || bandwidthUtilization.bitsOut/20 >= 85) {
                  <span
                    id="red-badge">
                    <mat-icon matTooltip="less than or equal to 85% (for 20x20)" matTooltipPosition="right">
                    highlight_off</mat-icon>
                  </span>
                }
              </td>
            }
            @if (throughputTest != null) {
              <td>
                @if (throughputTest.upload_speed/20 < 80 && throughputTest.download_speed/20 < 85) {
                  <span
                    id="green-badge">
                    <mat-icon matTooltip="Less than 80% (for 20x20)" matTooltipPosition="right">
                    check_circle_outline</mat-icon>
                  </span>
                }
                @if (throughputTest.upload_speed/20 >= 80 || throughputTest.download_speed/20 >= 85) {
                  <span
                    id="red-badge">
                    <mat-icon matTooltip="Greater than or equal to 80% (for 20x20)"
                      matTooltipPosition="right">
                    highlight_off</mat-icon>
                  </span>
                }
              </td>
            }
            @if (signalHealth != null) {
              <td>
                @if (signalHealth.sinr > 9) {
                  <span id="green-badge">
                    <mat-icon matTooltip="Greater than 9" matTooltipPosition="right">check_circle_outline
                    </mat-icon>
                  </span>
                }
                @if (signalHealth.sinr <= 9) {
                  <span id="red-badge">
                    <mat-icon matTooltip="Less than or equal to 9" matTooltipPosition="right">highlight_off
                    </mat-icon>
                  </span>
                }
              </td>
            }
            @if (signalHealth != null) {
              <td>
                @if (signalHealth.rsrq > -10) {
                  <span id="green-badge">
                    <mat-icon matTooltip="Greater than -10" matTooltipPosition="right">check_circle_outline
                    </mat-icon>
                  </span>
                }
                @if (signalHealth.rsrq <= -10) {
                  <span id="red-badge">
                    <mat-icon matTooltip="Less than or equal to -10" matTooltipPosition="right">
                    highlight_off</mat-icon>
                  </span>
                }
              </td>
            }
          </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>
</div>
<div class="main-card-wrapper">
  @if (circuit != null || fortigate != null || cradlepoints.length > 0 || cradlepointPort2Interface != null) {
    <div class="zone">
      <div class="zone-header">
        <span class="status-dot status-{{getWanDeviceSeverity()}}"></span>
        <h3 class="zone-title">WAN Devices</h3>
      </div>
      <div class="card-grid">
        @if (circuit != null) {
          <div class="device-card-wrap" [class.is-online]="circuit.loss < 10" [class.is-offline]="circuit.loss >= 10">
            <app-circuit-card [circuit]="circuit"></app-circuit-card>
          </div>
        }
        @if (fortigate != null) {
          <div class="device-card-wrap" [class.is-online]="fortigate.conn_status === 1"
            [class.is-warn]="fortigate.conn_status === 0" [class.is-offline]="fortigate.conn_status === 2">
            <app-fortigate-card [fortigate]="fortigate"></app-fortigate-card>
          </div>
        }
        @for (cradlepoint of cradlepoints; track cradlepoint) {
          <div class="device-card-wrap" [class.is-online]="cradlepoint.state === 'online'"
            [class.is-offline]="cradlepoint.state !== 'online'">
            <app-cradlepoint-card [cradlepoint]="cradlepoint"></app-cradlepoint-card>
          </div>
        }
        @if (cradlepointPort2Interface != null) {
          <div class="device-card-wrap"
            [class.is-online]="cradlepointPort2Interface.connection_state === 'connected'"
            [class.is-offline]="cradlepointPort2Interface.connection_state !== 'connected'">
            <mat-card>
              <mat-card-header>
                <mat-card-title>Cradlepoint Port 2</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <mat-divider></mat-divider>
                @if (cradlepointPort2Interface.connection_state == 'connected') {
                  <span id="network-health-badge-green">
                    <mat-icon matTooltip="Health: good" matTooltipPosition="right">network_check</mat-icon>
                  </span>
                }
                @if (cradlepointPort2Interface.connection_state != 'connected') {
                  <span id="network-health-badge-red">
                    <mat-icon matTooltip="Health: bad" matTooltipPosition="right">network_check</mat-icon>
                  </span>
                }
                <p><b>Status:</b> {{cradlepointPort2Interface.connection_state}}</p>
                <p><b>Hostname:</b> {{cradlepointPort2Interface.hostname}}</p>
                <p><b>MAC:</b> {{cradlepointPort2Interface.mac}}</p>
                <p><b>MTU:</b> {{cradlepointPort2Interface.mtu}}</p>
                <p><b>IP:</b> {{cradlepointPort2Interface.ipv4_address}}</p>
                <p><b>Subnet Mask:</b> {{cradlepointPort2Interface.netmask}}</p>
              </mat-card-content>
            </mat-card>
          </div>
        }
      </div>
    </div>
  }

  @if (bandwidthUtilization != null || posInterfaceThroughputTest != null || interfaceThroughput != null || signalHealth != null) {
    <div class="zone">
      <div class="zone-header">
        <span class="status-dot status-neutral"></span>
        <h3 class="zone-title">Throughput &amp; Signal</h3>
      </div>
      <div class="card-grid">
        @if (bandwidthUtilization != null) {
          <mat-card>
            <mat-card-header>
              <mat-card-title>Bandwidth Utilization</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <mat-divider></mat-divider>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Mb In</th>
                    <th scope="col">Mb Out</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{bandwidthUtilization.bitsIn}}</td>
                    <td>{{bandwidthUtilization.bitsOut}}</td>
                  </tr>
                </tbody>
              </table>
            </mat-card-content>
          </mat-card>
        }
        @if (posInterfaceThroughputTest != null) {
          <mat-card>
            <mat-card-header>
              <mat-card-title>POS Interface Throughput</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <mat-divider></mat-divider>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">In (Mb)</th>
                    <th scope="col">Out (Mb)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{posInterfaceThroughputTest.bitsIn}}</td>
                    <td>{{posInterfaceThroughputTest.outOctets}}</td>
                  </tr>
                </tbody>
              </table>
            </mat-card-content>
          </mat-card>
        }
        @if (interfaceThroughput != null) {
          <mat-card>
            <mat-card-header>
              <mat-card-title>Interface Throughput</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <mat-divider></mat-divider>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Interface</th>
                    <th scope="col">Bits In</th>
                    <th scope="col">Bits Out</th>
                  </tr>
                </thead>
                <tbody>
                  @for (interface of interfaceThroughput | keyvalue; track interface) {
                    <tr>
                      <td>{{interface.key}}</td>
                      <td>{{interface.value.in}}</td>
                      <td>{{interface.value.out}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </mat-card-content>
          </mat-card>
        }
        @if (signalHealth != null) {
          <mat-card>
            <mat-card-header>
              <mat-card-title>Signal Health</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <mat-divider></mat-divider>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Strength</th>
                    <th scope="col">RSRP</th>
                    <th scope="col">RSRQ</th>
                    <th scope="col">SINR</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{signalHealth.name}}</td>
                    <td>{{signalHealth.signal_strength}}</td>
                    <td>{{signalHealth.rsrp}}</td>
                    <td>{{signalHealth.rsrq}}</td>
                    <td>{{signalHealth.sinr}}</td>
                  </tr>
                </tbody>
              </table>
            </mat-card-content>
          </mat-card>
        }
      </div>
    </div>
  }
</div>